import { Button } from '@vivaahealth/design-system';

interface EmergencyContactButtonProps {
  icon?: React.ReactNode;
  onClickHandler: () => void;
  message: string;
  variant?: 'outlined' | 'text' | 'primary';
  colorVariant?: 'primary' | 'secondary' | 'danger';
  size?: 'small' | 'medium';
}

const EmergencyContactButton = (props: EmergencyContactButtonProps) => {
  const {
    variant = 'outlined',
    colorVariant = 'primary',
    size = 'medium',
    icon,
    onClickHandler,
    message,
  } = props;
  return (
    <Button
      variant={variant}
      colorVariant={colorVariant}
      size={size}
      startIcon={icon ?? null}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        onClickHandler();
      }}
      fullWidth
    >
      {message}
    </Button>
  );
};

export default EmergencyContactButton;
